// toggleUploadJobMoreModal.js
'use strict';
import { MERGE_OPERATION_DATA, REMOVE_OPERATION_DATA } from '../ActionTypes.js';
import removeModals from '../action/removeModals.js';
import addModal from '../action/addModal.js';

export const MODAL_ID = 'UploadJobMoreModal';

/**
 * Toggle upload failed modal
 * @kind action
 * @param {string} {uploadJobId} - upload job id.
 * @param {boolean} {isOpen} - is open modal.
 * @return {Promise} Action promise.
 */
const toggleUploadJobMoreModal =
  ({ uploadJobId, isOpen } = {}) =>
  async dispatch => {
    if (isOpen) {
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['modal', MODAL_ID],
          data: {
            uploadJobId,
          },
        },
      });
      return dispatch(
        addModal({
          id: MODAL_ID,
          transitionStatus: 'opening',
          isHigherThanAll: true,
        })
      );
    }
    await dispatch(
      removeModals({
        ids: [MODAL_ID],
        transitionStatus: 'closing',
      })
    );
    return dispatch({
      type: REMOVE_OPERATION_DATA,
      payload: {
        selectPath: ['modal', MODAL_ID],
      },
    });
  };

export default toggleUploadJobMoreModal;
